import React, { FC, useState } from "react";

import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import {
  ImageAlbum as FotoIcon,
  PlaylistCheck as TarefaIcon,
  ClipboardClock as AvaliacaoIcon,
  AccountGroup as ReuniaoIcon,
  Information as MensagensGeraisIcon,
} from "mdi-material-ui";

import { ZoomOnScroll } from "components/ZoomOnScroll";
import { Environment } from "configs";
import { useAppSelector } from "store";
import {
  EMensagemCategoriaTipo,
  IMensagemCategoria as IMMMensagemCategoria,
} from "@deltasge/marauders-map";
import { Float } from "components/Buttons/Float";
import { IMensagemCategoria } from "../utilMensagem";

export const Icon: FC<{ categoria: IMMMensagemCategoria }> = ({
  categoria,
}) => {
  return categoria.tipo ==
    EMensagemCategoriaTipo["Conteúdo para avaliações"] ? (
    <AvaliacaoIcon />
  ) : categoria.tipo == EMensagemCategoriaTipo.Fotos ? (
    <FotoIcon />
  ) : categoria.tipo == EMensagemCategoriaTipo["Tarefas de Casa"] ? (
    <TarefaIcon />
  ) : categoria.tipo == EMensagemCategoriaTipo.Reuniões ? (
    <ReuniaoIcon />
  ) : (
    <MensagensGeraisIcon />
  );
};

export const Add: FC<{
  handleAddMensagem: (categoria: IMensagemCategoria) => void;
  categoria?: IMMMensagemCategoria;
  categorias: IMMMensagemCategoria[];
}> = ({ handleAddMensagem, categoria, categorias }) => {
  const [speedDialOpen, setSpeedDialOpen] = useState(false);

  const rightbarIsOpen = useAppSelector(
    (state) => state.layout.rightbar.isOpen
  );

  if (!categoria) {
    return (
      <ZoomOnScroll>
        <SpeedDial
          FabProps={{
            color: "secondary",
          }}
          onClose={() => setSpeedDialOpen(false)}
          onOpen={() => setSpeedDialOpen(true)}
          open={speedDialOpen}
          ariaLabel="Add publicação"
          sx={({ spacing }) => ({
            position: "fixed",
            bottom: spacing(2),
            right: !rightbarIsOpen
              ? spacing(2)
              : spacing(Environment.DRAWER_WIDTH + 2),
          })}
          icon={<SpeedDialIcon />}
        >
          {categorias.map((categoria) => (
            <SpeedDialAction
              key={`area-${categoria.id}`}
              icon={<Icon categoria={categoria} />}
              tooltipTitle={categoria.nome}
              onClick={() => {
                setSpeedDialOpen(false);
                const { id, ...rest } = categoria;
                if (id) {
                  handleAddMensagem({ ...rest, id });
                }
              }}
            />
          ))}
        </SpeedDial>
      </ZoomOnScroll>
    );
  }
  return (
    <Float
      onClick={() => {
        const { id, ...rest } = categoria;
        if (id) {
          handleAddMensagem({ ...rest, id });
        }
      }}
      title={categoria.nome}
    />
  );
};
